import { render, staticRenderFns } from "./DenominationSetup.vue?vue&type=template&id=5dfe2a42&"
import script from "./DenominationSetup.vue?vue&type=script&lang=js&"
export * from "./DenominationSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports